import { memo } from 'react';

import { Flex } from '@/components/core';
import { ActionRunTest, HttpHeaders, HttpUrl } from '@/components/flow';

export type ExportN8NConfigurationProps = object;

// eslint-disable-next-line no-empty-pattern
const IExportN8NConfiguration = ({}: ExportN8NConfigurationProps = {}) => {
  return (
    <Flex col className="gap-md p-md">
      <HttpUrl placeholder="https://<instance>.app.n8n.cloud/..." />
      <HttpHeaders />
      <ActionRunTest />
    </Flex>
  );
};

export const ExportN8NConfiguration = memo(IExportN8NConfiguration) as typeof IExportN8NConfiguration;
